import { useState } from "react"
import CampoTexto from "../CampoTexto"
import Botao from "../Botao";
import Mensagem from "../Mensagem";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "../../contextos/AuthContext"; // Importa o hook useAuth do contexto de autenticação para acessar o estado do usuário logado e funções relacionadas à autenticação
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3'; // Importa o hook useGoogleReCaptcha para integrar o reCAPTCHA v3 do Google, que ajuda a proteger o formulário contra bots e abusos automatizados


//Cadastro recebe uma prop usuario que é passada pelo MenuLink para location usando state no Menu para verificar se o usuário está logado e exibir os dados do cadastro para edição, caso contrário, o formulário é exibido em branco para um novo cadastro
const CadastroUsuario = () => {
    const { executeRecaptcha } = useGoogleReCaptcha();
    const location = useLocation(); // Hook para acessar o estado passado pela rota, que pode conter os dados do usuário logado para edição
    const navigate = useNavigate(); // Hook para navegação programática 
    const usuarioLogado = useAuth().dadosUsuario; // Hook para acessar o contexto de autenticação e obter os dados do usuário logado
    console.log("Usuario logado no CadastroUsuario:", usuarioLogado); // Log para verificar o conteúdo de usuarioLogado


    /*Definindo os estados para os campos do formulário conforme usuário logado ou não
      Esses estados serão atualizados conforme o usuário digita nos campos
    useState é um Hook do React que permite adicionar o estado a um componente funcional
      Cada useState retorna um par: o valor atual do estado e uma função para atualizá-lo
    */
    
    const [email, setEmail] = useState(usuarioLogado?.user || ''); // Se houver um usuário logado, preenche o email, caso contrário, inicia como string vazia
    const [nome, setNome] = useState(usuarioLogado?.nome || '');
    const [fone, setFone] = useState(usuarioLogado?.fone || '');
    const [senha1, setSenha1] = useState('');
    const [senha2, setSenha2] = useState(''); 
    
    // Atualiza o estado do checkbox recebeEmail com base no valor do usuário logado, se houver, ou define como true por padrão para novos cadastros
    const [recebeEmail, setRecebeEmail] = useState(
        usuarioLogado ? (usuarioLogado.recebeEmail == 1 || usuarioLogado.recebeEmail === true) : true
    );
    
    const [mensagem, setMensagem] = useState({ texto: '', tipo: '' });//Controla o state dos dados do componente Mensagem para exibir feedback ao usuário. Tipo recebe o status da resposta da API para definir o estilo da mensagem (ex: sucesso, erro, aviso) para aplicar estilo conforme o tipo recebido, conforme o componente mensagem .
    const [carregando, setCarregando] = useState(false);//Para controlar o state de carregamento durante a requisição

    const [obrigatorio, setObrigatorio] = useState(usuarioLogado ? false : true); // State para controlar se os campos são obrigatórios ou não, inicialmente definido como true para novos cadastros
    const [editavel, setEditavel] = useState(usuarioLogado ? false : true); // State para controlar se os campos são editáveis ou não, inicialmente definido como true para novos cadastros


    /* Critérios para validação da senha
      O .test() é um método das expressões regulares (regex) no JavaScript. Ele verifica se uma string corresponde ao padrão definido e retorna true ou false.

      Exemplo javascript: 
      /padrão/.test('string a testar') // → true ou false
    */
    const criterios = {
        tamanho:    senha1.length >= 6 && senha1.length <= 12,
        maiuscula:  /[A-Z]/.test(senha1),
        minuscula:  /[a-z]/.test(senha1),
        numero:     /[0-9]/.test(senha1),
        semSimbolo: !/[ !@#$%^&*_=+\-]/.test(senha1),
        senhasIguais: senha1 === senha2 && senha2.length > 0 
    };

    /* Object.values(criterios)
        Extrai apenas os valores do objeto criterios, transformando em um array:
        Exemplo: 
        const criterios = {
        tamanho:      true,
        maiuscula:    false,
        minuscula:    true,
        numero:       true,
        semSimbolo:   true,
        senhasIguais: false
        };

        Object.values(criterios) 
        // → [true, false, true, true, true, false]
    */
    const senhaValida = Object.values(criterios).every(Boolean);

    
    
    const aoSalvar = async(evento) => {
        // 1. Essencial: Impede o recarregamento da página e a "sujeira" na URL
        evento.preventDefault();
        setCarregando (true); // Trava o botão cadastrar durante a requisição
        
        // Limpa mensagens anteriores
        setMensagem({ texto: '', tipo: '' });

        // ✅ Gera o token antes de enviar
        if (!executeRecaptcha) {
            setMensagem({ texto: 'reCAPTCHA não carregado.', tipo: 'erro' });
            return;
        }

        // Chama a função executeRecaptcha com o nome da ação 'cadastro' para gerar o token do reCAPTCHA
        const tokenCaptcha = await executeRecaptcha('cadastro'); // ← nome da ação
        
        console.log("Token do reCAPTCHA gerado:", tokenCaptcha); // Log para verificar o token gerado

        
        // Recupera o token do storage
        const token = localStorage.getItem('viver_token');

        
        // 2. Monta o objeto com os estados que você já tem (nome, email, fone, etc.)
        const dadosParaEnvio = {
          nome: nome,
          email: email,
          fone: fone,
          senha1: senha1,
          senha2: senha2,
          recebeemail: recebeEmail, // O booleano do seu checkbox
          tokenCaptcha: tokenCaptcha // Adiciona o token do reCAPTCHA aos dados para envio
        };

        try  {

            // 3. Usa a variável de ambiente que agora está funcionando
            // O React substitui isso em tempo de execução. A variável baseUrl conterá a URL da API definida no arquivo .env

            const endpoint = usuarioLogado ? '/user-edit' : '/user-new'; // Define o endpoint com base no estado de login do usuário
            const url =  `${process.env.REACT_APP_API_URL}${endpoint}`;

            const headers = {
              'Content-Type': 'application/json'
            };

            // Se houver um token (usuário logado editando), adicionamos ao cabeçalho
            if (token) {
                headers['Authorization'] = `Bearer ${token}`;
            }
            
            // Envia os dados do usuário para a API
            const resposta = await fetch(url, {  
                method: 'POST',
                headers: headers,
                body: JSON.stringify(dadosParaEnvio),
                
              });
              
              if (resposta.ok) {
                const dadosRetorno = await resposta.json();
                console.table(dadosRetorno);
                
                if (dadosRetorno.status === 'sucesso') {

                    //Se o usuário tiver logado atualizamos os dados do localStorage para refletir as alterações feitas no cadastro, como nome ou preferências de email, garantindo que o Header e outras partes do site exibam as informações atualizadas sem a necessidade de um novo login. Se for um novo cadastro, o token e os dados do usuário já foram salvos no localStorage durante o processo de login automático após a criação do usuário, então não é necessário fazer nada aqui nesse caso.
                    if (usuarioLogado) {
                      // 2. Salva dados básicos do usuário para o Header (Nome/Foto)
                      localStorage.setItem('viver_dados', JSON.stringify(dadosRetorno.dados));
                    }

                    setMensagem({ texto: dadosRetorno.mensagem, tipo: dadosRetorno.status });
                    // Limpa os campos após o envio se for inclusão, caso contrário, mantém os dados para edição

                    //Passamos o state para a página de resultado usando o navigate do react-router-dom, que permite enviar um objeto de estado junto com a navegação. Assim, a página de resultado pode acessar esse estado para exibir a mensagem apropriada. Só usaremos a página resultado para exibir mensagens de sucesso. Erros serão exibidos na própria página de cadastro para que o usuário possa corrigir sem perder os dados já preenchidos.
                    navigate('/resultado', { 
                          state: { 
                            status: dadosRetorno.status,
                            mensagem: dadosRetorno.mensagem
                          }
                        });

                    if (!usuarioLogado) {
                      setEmail('');
                      setNome('');
                      setFone('');
                      setSenha1('');
                      setSenha2('');
                      setRecebeEmail(true); 
                    }


                    
                    setCarregando (false); // Destrava o botão cadastrar após o processamento da requisição
                    return;

                }else {

                    // Se o erro for 401, significa que o token expirou durante a edição
                    if (resposta.status === 401) {
                        localStorage.removeItem('viver_token');
                        navigate('/login', { state: { mensagem: "Sessão expirada. Logue novamente." } });
                    return;
                    }

                    setMensagem({ texto: dadosRetorno.mensagem, tipo: dadosRetorno.status });
                    setCarregando (false); // Destrava o botão cadastrar após o processamento da requisição
                    
                  return;
                } 
                 
              }else {
                /// Aqui o PHP enviou um erro proposital (ex: 400 Bad Request)
                
                const erroRetorno = await resposta.json();
                console.table(erroRetorno);
                setMensagem({ 
                            texto: erroRetorno.mensagem || "Erro ao processar cadastro.", 
                            tipo: erroRetorno.status || 'erro'});
                setCarregando (false); // Destrava o botão cadastrar após o processamento da requisição

                
              }

        } catch (error) {
            setMensagem({ texto: error.message, tipo: 'erro' });
            console.error("Erro ao cadastrar usuário:", error);
            setCarregando (false); // Destrava o botão cadastrar após o processamento da requisição
        }       
        
        
    }


  return (    
        

        
        <div className="container-fluid mt-5">
            {usuarioLogado ? 
                          <h1 className="h1">Edição de Cadastro</h1> : <h1 className="h1">Inclusão de usuario</h1>
            }
            
            

                <form id="form" className="p-5" onSubmit={aoSalvar}>
                  
                  <div className="row mb-3 "> 
                    <CampoTexto 

                      label="Email"
                      labelClass="form-label fs-5"
                      className="form-control form-control-lg fs-3"
                      wrapperClass="col-12 col-md-6"
                      tipo="email"
                      placeholder="Digite seu email"
                      obrigatorio={true}
                      editavel={editavel} // Torna o campo de email somente leitura se o usuário estiver logado
                      tamanhoMaximo={256}
                      nome="email"
                      id="email"
                      /*O valor do campo será controlado pelo estado email */
                      valor={email} 
                      /*Quando o usuário digitar algo, a função setEmail será chamada para atualizar o estado*/
                      aoDigitado={ valor => setEmail(valor)} 
                      
                    />
                  </div>

                  <div className="row mb-3">
                    <CampoTexto 
                      label="Nome"
                      labelClass="form-label fs-5"
                      className="form-control form-control-lg fs-3"
                      wrapperClass="col-12 col-md-6"
                      tipo="text"
                      placeholder="Digite seu nome"
                      obrigatorio={true}
                      editavel={true} // O campo de nome é sempre editável, independentemente do estado de login
                      tamanhoMaximo={50}
                      nome="nome"
                      id="nome"
                      valor={nome} 
                      aoDigitado={valor => setNome(valor)}
                    />
                  </div>

                  <div className="row mb-3">
                    <CampoTexto 
                      label="Fone"
                      labelClass="form-label fs-5"
                      className="form-control form-control-lg fs-3"
                      wrapperClass="col-12 col-md-6"
                      tipo="text"
                      placeholder="Digite seu celular com DDD"
                      obrigatorio={true}
                      editavel={true} // O campo de fone é sempre editável, independentemente do estado de login
                      tamanhoMaximo={11}
                      nome="fone"
                      id="fone"
                      valor={fone} 
                      aoDigitado={valor => setFone(valor)}
                    />
                  </div>

                  <div className="row mb-3">
                    <CampoTexto 
                      label="Senha"
                      labelClass="form-label fs-5"
                      className="form-control form-control-lg fs-3" 
                      wrapperClass="col-12 col-md-6"
                      tipo="password"
                      placeholder="Digite sua senha"
                      obrigatorio={obrigatorio} // O campo de senha é obrigatório apenas para novos cadastros
                      editavel={true} // O campo de senha é sempre editável, independentemente do estado de login
                      tamanhoMaximo={20}
                      nome="senha1"
                      id="senha1"
                      valor={senha1} 
                      aoDigitado={valor => setSenha1(valor)}
                    />
                  </div>

                  

                  <div className="row mb-3">
                    <CampoTexto 
                      label="Confirme a Senha"
                      labelClass="form-label fs-5"
                      className="form-control form-control-lg  fs-3"
                      wrapperClass="col-12 col-md-6"
                      tipo="password"
                      placeholder="Digite sua senha novamente"
                      obrigatorio={obrigatorio} // O campo de confirmação de senha é obrigatório apenas para novos cadastros
                      editavel={true} // O campo de confirmação de senha é sempre editável, independentemente do estado de login
                      tamanhoMaximo={20}
                      nome="senha2"
                      id="senha2"
                      valor={senha2} 
                      aoDigitado={valor => setSenha2(valor)}
                    />
                  </div>

                  {/* Validação da sennha */}
                  {senha1.length > 0 && (
                      <ul className="col-12 col-md-6 list-unstyled mt-2 fs-4">
                          <li className={criterios.tamanho    ? 'text-success' : 'text-danger'}><i className={`bi bi-${criterios.tamanho    ? 'check' : 'x'}-circle-fill me-1`}></i>6 a 12 caracteres</li>
                          <li className={criterios.maiuscula  ? 'text-success' : 'text-danger'}><i className={`bi bi-${criterios.maiuscula  ? 'check' : 'x'}-circle-fill me-1`}></i>1 letra maiúscula</li>
                          <li className={criterios.minuscula  ? 'text-success' : 'text-danger'}><i className={`bi bi-${criterios.minuscula  ? 'check' : 'x'}-circle-fill me-1`}></i>1 letra minúscula</li>
                          <li className={criterios.numero     ? 'text-success' : 'text-danger'}><i className={`bi bi-${criterios.numero     ? 'check' : 'x'}-circle-fill me-1`}></i>1 número</li>
                          <li className={criterios.semSimbolo ? 'text-success' : 'text-danger'}><i className={`bi bi-${criterios.semSimbolo ? 'check' : 'x'}-circle-fill me-1`}></i>Sem símbolos</li>
                          <li className={criterios.senhasIguais ? 'text-success' : 'text-danger'}><i className={`bi bi-${criterios.senhasIguais ? 'check' : 'x'}-circle-fill me-1`}></i>Senhas conferem</li>
                      </ul>
                  )}

                  <div className="row mb-3">
                    <div className="form-check">
                      <input 
                        className="form-check-input form-check-input-lg fs-3" 
                        type="checkbox" 
                        name="recebeemail" 
                        id="recebeemail" 
                        checked={recebeEmail}
                        onChange={evento => setRecebeEmail(evento.target.checked)}
                        />
                      <label className="form-check-label fs-3" htmlFor="recebeemail">Receber email? </label>

                    </div>
                        <div className="form-text mt-5" ><p className="fs-5 text" >Concordo que os dados pessoais fornecidos acima serão utilizados para envio de conteúdo informativo, analítico e publicitário sobre produtos, serviços e assuntos gerais, nos termos da Lei Geral de Proteção de Dados. Ao marcar esta opção, você autoriza o site Viver Espírita a coletar seus dados pessoais e a enviar notificações por e-mail ou outros meios e concordo com sua Política de Privacidade . O recebimento de email pode ser revogado a qualquer momento desativando esta opção no seu cadastro.</p></div> 
                  </div>  

                  <Mensagem mensagem={mensagem.texto} tipo={mensagem.tipo} />

                  {/* O botão de cadastro é desativado enquanto o carregamento está em andamento */}
                  <Botao className="btn btn-primary btn-lg" tipo="submit" aoClicar={null} disabled={carregando} >
                     {carregando ? 'Enviando...' : 'Salvar'}
                  </Botao>
                </form>
        </div>
  )
}

export default CadastroUsuario
